(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enexbuy-watch-and-shop"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.watch-shop').forEach(function (section) {
    var modal = section.querySelector('.watch-modal');
    if (!modal) return;
    var backdrop = modal.querySelector('.watch-modal__backdrop');
    var closeBtn = modal.querySelector('.watch-modal__close');
    var videoWrap = modal.querySelector('.watch-modal__video-wrap');
    var shopBtn = modal.querySelector('.watch-modal__shop');
    var activeVideo = null;
    var activeSlot = null;

    function openModal(card) {
      var slot = card.querySelector('.watch-card__video-slot');
      var video = slot ? slot.querySelector('.watch-card__video') : null;
      if (!video) return;

      activeSlot = slot;
      activeVideo = video;
      videoWrap.appendChild(video);

      shopBtn.href = card.dataset.productUrl || '#';
      shopBtn.textContent = card.dataset.shopLabel || 'Shop Now';

      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      video.currentTime = 0;
      video.play();
    }

    function closeModal() {
      if (activeVideo) {
        activeVideo.pause();
        activeVideo.currentTime = 0;
        if (activeSlot) activeSlot.appendChild(activeVideo);
      }
      activeVideo = null;
      activeSlot = null;
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    section.querySelectorAll('.watch-card__poster').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn.closest('.watch-card'));
      });
    });

    videoWrap.addEventListener('click', function () {
      if (!activeVideo) return;
      if (activeVideo.paused) { activeVideo.play(); } else { activeVideo.pause(); }
    });

    closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
